"use client"
import { useState } from "react"
import { useLocale, useTranslations } from 'next-intl'
import { useLocalizedField } from '@/hooks/useLocalizedField'

export default function CircuitCard({ item }: any) {
  const locale = useLocale()
  const t = useTranslations()
  const { getLocalizedField } = useLocalizedField()
  
  const name = getLocalizedField(item, 'name', item.name || 'Unknown')
  const description = getLocalizedField(item, 'description', item.description || '')
  const difficulty = getLocalizedField(item, 'difficulty', item.difficulty || '')

    return (
        <div className="
            bg-white rounded-3xl shadow-lg overflow-hidden w-full mx-auto 
            transition-all duration-300 hover:shadow-xl hover:-translate-y-1
            flex flex-col
            h-full
        " dir={locale === 'ar' ? 'rtl' : 'ltr'}>
            {/* IMAGE */}
            <div className="relative w-full h-48 overflow-hidden">
                <img
                    src={item.images?.[0]}
                    alt={name}
                    className="w-full h-full object-cover rounded-3xl border-b-4 border-primary"
                />

                {/* Duration */}
                {item.number && (
                    <div className={`absolute top-3 ${locale === 'ar' ? 'right-3' : 'left-3'} bg-primary/90 text-white px-3 py-1 rounded-full text-sm font-medium`}>
                        {item.number} {t('common.days')}
                    </div>
                )}
            </div>

            {/* CONTENT */}
            <div className="p-5 flex flex-col flex-grow">
                <div className={`flex justify-between items-start mb-2 ${locale === 'ar' ? 'flex-row-reverse' : ''}`}>
                    <h3 className="text-xl font-bold text-gray-800">{name}</h3>

                    {difficulty && (
                        <span className="text-xs font-medium px-2 py-1 bg-gray-100 text-gray-600 rounded-full">
                            {difficulty}
                        </span>
                    )}
                </div>

                {description && (
                    <p className="text-gray-600 mt-2 text-sm line-clamp-2">
                        {description}
                    </p>
                )}

                {/* BUTTON */}
                <div className={`mt-auto flex pt-4 ${locale === 'ar' ? 'justify-start' : 'justify-end'}`}>
                    <a
                        href={`/${locale}/circuits/${item.slug}`}
                        className="text-primary font-semibold hover:underline"
                    >
                        {t('circuits.viewDetails')}
                    </a>
                </div>
            </div>
        </div>
    )
}
